var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 button",class:{ highlight: _vm.isHighlighted }},[_c('span',{staticClass:"name serif"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }